<template>
  <div class="footer">
    <div class="copyright">
      Copyright
      <a-icon type="copyright" /> 2019 <span>{{ copyright }}</span>
      <br />
      <a href="https://beian.miit.gov.cn/" target="_blank" style="margin-right: 10px">冀ICP备17029854号-1</a>
      <img class="logos" src="https://beian.mps.gov.cn/web/assets/logo01.6189a29f.png" style="width: 16px" />
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=13019902000276" rel="noreferrer" target="_blank"
        >冀公网安备13019902000276号</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalFooter',
  data() {
    return {}
  },
  computed: {
    copyright() {
      return this.$store.state.brand.copyright
    },
  },
}
</script>

<style lang="less" scoped>
.footer {
  padding: 0 16px;
  margin: 48px 0 24px;
  text-align: center;

  .links {
    margin-bottom: 8px;

    a {
      color: rgba(0, 0, 0, 0.45);

      &:hover {
        color: rgba(0, 0, 0, 0.65);
      }

      &:not(:last-child) {
        margin-right: 40px;
      }
    }
  }
  .copyright {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
</style>
